import React from 'react';
import PropTypes from 'prop-types';
import { COUNTRY_DATA } from 'pgdb-data-layer/lib/Constants/CountryCode';

const CountryDropdown = ({
   id,
   placeholder,
   disabled,
   value,
   onBlur = null,
   onChange = null,
   label = null,
   inputValid = true,
   mandatory = false,
}) => {
   const inputClasses = `browser-default form-control input-validation-error select-input${
      disabled ? 'input-disabled' : ''
   }${inputValid ? '' : 'input-invalid'}`;

   return (
      <>
         {label && (
            <span className="grey2-text input-header">
               {label}
               {mandatory && <span className="text-red"> *</span>}
            </span>
         )}
         <select
            className={inputClasses}
            id={id}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
         >
            {COUNTRY_DATA.map((element, _) => {
               return (
                  <option key={element.value} value={element.value}>
                     {element.name}
                  </option>
               );
            })}
         </select>
      </>
   );
};

const { string, bool, func } = PropTypes;

CountryDropdown.propTypes = {
   placeholder: string,
   id: string,
   value: string,
   disabled: bool,
   onBlur: func,
   onChange: func,
   label: string,
   inputValid: bool,
   mandatory: bool,
};

CountryDropdown.defaultProps = {
   placeholder: '',
   id: '',
   value: '',
   disabled: false,
   onBlur: null,
   label: '',
   onChange: null,
   inputValid: true,
   mandatory: false,
};

export default CountryDropdown;
